<template>
  <form action="">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">New project</p>
        <button
          type="button"
          class="delete"
          @click="$emit('close')"/>
      </header>
      <section class="modal-card-body">
        <b-field label="Name">
          <b-input
            v-model="name"
            required>
          </b-input>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-primary" @click="formSubmit">Create</button>
      </footer>
    </div>
  </form>
</template>

<script>

import ProjectService from '@/services/ProjectService'

export default {
  name: 'NewProjectModal',
  data () {
    return {
      name: ''
    }
  },
  methods: {
    formSubmit() {
      ProjectService.new(this.name)
    }
  }
}
</script>
